import { History, TotalProgress, ElementIds, Elements } from 'types';
import { mixParents } from 'helpers/mix';
import { sortParents } from 'helpers/sort';
import { mapFromList } from 'helpers/progress';

class ProgressManager {
  public analyze(elements: Elements, history: History) {
    const { totalProgress, timestamps } = this.analyzeHistory(elements, history);
    const { base, final: finalList } = this.analyzeProgress(elements, totalProgress);
    const { primes } = this.analyzeBase(elements);
    const final = mapFromList(finalList);
    const progressList = totalProgress.filter(
      (id) => !final.hasOwnProperty(id) && !base.includes(id) && !primes.includes(id),
    );

    return {
      progress: mapFromList(progressList),
      base,
      final,
      primes,
      timestamps,
    };
  }

  public analyzeHistory(elements: Elements, history: History) {
    const progress: { [id: string]: boolean } = {};
    const timestamps: TotalProgress = [];

    history.forEach(({ mother, father, timestamp }) => {
      const parents = sortParents([mother, father]);
      const children = mixParents(elements, parents);
      children.forEach((id) => {
        if (progress.hasOwnProperty(id)) return;

        progress[id] = true;
        timestamps.push({ id, timestamp });
      });
    });

    return {
      totalProgress: Object.keys(progress),
      timestamps,
    };
  }

  public analyzeProgress(elements: Elements, progress: ElementIds) {
    const base: ElementIds = [];
    const final: ElementIds = [];

    progress.forEach((id) => {
      const element = elements[id];
      if (element.base) {
        base.push(id);
      }

      if (element.final) {
        final.push(id);
      }
    });

    return {
      base,
      final,
    };
  }

  public analyzeBase(elements: Elements) {
    const primes: ElementIds = [];
    Object.entries(elements).forEach(([id, element]) => {
      if (!element.prime) {
        return;
      }

      primes.push(id);
    });

    return {
      primes,
    };
  }
}

export default new ProgressManager();
